import './course-card.scss';
import StatusChiclet from "../../../Chiclets/StatusChiclet/StatusChiclet";
import ButtonKMQ from "../../../Button/ButtonKMQ";
import {PlarCardType} from "../PlarCard";
import ProgressChiclet from "../../../Chiclets/ProgressChiclet/ProgressChiclet";
import {ChicletTypes} from "../../../../../constants/ui/types/ChicletTypes";
import CourseCardStatus from "./CourseCardStatus";
import {ButtonTypes} from "../../../../../constants/ui/types/ButtonTypes";
import moment from "moment";
import WarningIcon from '../../../../../assets/icons/error/warning.svg';
import PaidIcon from '../../../../../assets/icons/UI/icons/paid-icon.svg';
import ArrowsIcon from '../../../../../assets/icons/UI/icons/updating-arrows.svg';

export interface CourseCardProps {
  type?: PlarCardType,
  title: string,
  code?: string,
  match?: string
  onClick: () => void,
  buttonText: string,
  buttonDisabled?: boolean,
  chicletText?: string,
  statusText?: string[],
  cpl_eligible?: boolean,
  payment_status: string,
  changePaymentStatus: () => void,
  hasQuiz?: boolean,
  quizDue?: string,
  viewQuiz?: () => void,
  quiz_submitted?: boolean
  active_catalogue_version?: boolean,
  updated_by_previous_recommendation?: boolean,
  course_recommendation_id?: string,
  generateMatch: () => void
}

const CourseCard = (props: CourseCardProps) => {
  const {
    type = PlarCardType.Not_started,
    title,
    code,
    onClick,
    buttonText,
    cpl_eligible,
    hasQuiz,
    quizDue,
    viewQuiz,
    quiz_submitted,
    active_catalogue_version,
    updated_by_previous_recommendation,
    course_recommendation_id,
    buttonDisabled,
    generateMatch
  } = props;

  return <div
    className={`course-card course-card-${type} ${updated_by_previous_recommendation ? 'course-card-submitted' : ''}`}>
    {
      cpl_eligible
        ? <StatusChiclet
          text={window.screen.width > 420 ? 'Credit for Prior Learning Eligible' : 'CPL Eligible'}
        />
        : <ProgressChiclet
          type={ChicletTypes.Not_started}
          text={'Credit not Eligible for Prior Learning'}
        />
    }

    <CourseCardStatus {...props}/>

    {
      code ?
        <div className={'course-card-code'}>
          {code}
        </div>
        : null
    }


    <div className={'course-card-title'}>
      {title}
    </div>

    {
      updated_by_previous_recommendation
        ? <div className={'course-card-updated'}>
          <img
            src={PaidIcon}
            alt={'paid'}
            className={'course-card-updated-paid'}
          />
          <span className={'course-card-updated-text'}>
            Submitted
          </span>
          <img
            src={ArrowsIcon}
            alt={'updating arrows'}
            className={'course-card-updated-arrows'}
          />
        <span className={`course-card-updated-status course-card-updated-status-${type}`}>
          {
            type === PlarCardType.Accepted
              ? 'Approved'
              : type === PlarCardType.Rejected
                ? 'Rejected'
                : 'Pending review'
          }
        </span>
        </div>
        : null
    }

    <div className={'course-card-footer'}>
      <span className={'course-card-footer-labels'}>
          {quizDue
            ? <span className={'course-card-footer-due'}>
              <span className={'course-card-footer-due-dot'}/>
              <span>
                Quiz due date: {moment(quizDue).format('MMM D, YYYY').toString()}
              </span>
          </span>
            : null
          }
        {
          !active_catalogue_version
            ? <span className={'course-card-footer-warning'}>
              <img
                src={WarningIcon}
                alt={'warning'}
              />
              <span className={'course-card-footer-warning-text'}>
                Attention required
              </span>
            </span>
            : null
        }
      </span>
      <div className={'course-card-footer-buttons'}>
        {
          ((hasQuiz || quiz_submitted) && viewQuiz)
            ? <ButtonKMQ onClick={viewQuiz} type={quiz_submitted ? ButtonTypes.Secondary : ButtonTypes.Tertiary}>
              {quiz_submitted ? 'View answers' : 'Start quiz'}
            </ButtonKMQ>
            : null
        }
        {
          !course_recommendation_id
            ? <ButtonKMQ onClick={generateMatch} type={ButtonTypes.Secondary}>
              Generate match score
            </ButtonKMQ>
            : null
        }
        <ButtonKMQ onClick={onClick} disabled={buttonDisabled}>
          {buttonText}
        </ButtonKMQ>
      </div>
    </div>
  </div>
}

export default CourseCard;